<template>
  <section
    :id="id"
    class="expertise_oskelly"
  >
    <div class="osk-wrapper">
      <div class="title_block_sm">
        {{ title }}
      </div>

      <div class="expertise_oskelly_left_right_block">
        <div class="expertise_left_block">
          <div class="block block_false">
            <img src="~assets/img/info/sneaker-example.png">
          </div>

          <div class="block block_true">
            <img src="~assets/img/info/sneaker-example.png">
          </div>
        </div>

        <div class="expertise_right_block">
          <div class="block">
            <div class="name_block">
              {{ $t('components.info.oskellyExpertise.block1.text1') }}
            </div>

            <p>{{ $t('components.info.oskellyExpertise.block1.text2') }}</p>
          </div>

          <div class="block">
            <div class="name_block">
              {{ $t('components.info.oskellyExpertise.block2.text1') }}
            </div>

            <p>{{ $t('components.info.oskellyExpertise.block2.text2') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ANCHORS } from '~/components/info/anchors';

const props = withDefaults(defineProps<{
  type: 'buy' | 'sell'
}>(), {});

const { t } = useI18n();

const id = {
  buy: ANCHORS.GUARANTEE,
  sell: ANCHORS.OSKELLY_EXPERTISE,
}[props.type];
const title = {
  buy: t('components.info.oskellyExpertise.title.buy'),
  sell: t('components.info.oskellyExpertise.title.sell'),
}[props.type];
</script>

<style scoped lang="scss">
section.expertise_oskelly {
  padding: 80px 0 75px;
  border-top: 1px solid rgba(51, 51, 51, 0.1);
}

section.expertise_oskelly .expertise_oskelly_left_right_block {
  margin-top: 41px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block {
  float: left;
  width: calc(100% - 650px);
  max-width: 395px;
  margin-top: 3px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block .block {
  margin-bottom: 25px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block .block .name_block {
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  line-height: 18px;
  font-size: 16px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block .block p {
  color: #828282;
  line-height: 21px;
  font-size: 14px;
  margin-top: 7px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block {
  float: right;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block {
  width: 290px;
  height: 197px;
  border-radius: 0 0 2px 2px;
  border: 1px solid rgba(189, 189, 189, 0.6);
  position: relative;
  margin: 0 7px;
  box-sizing: border-box;
  padding-bottom: 20px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block:last-child {
  margin-left: 23px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_false:after {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: 3px;
  background: #FF0000;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_false:before {
  content: "";
  position: absolute;
  bottom: 20px;
  left: calc(50% - 9px);
  background: url("assets/img/filled-close-negative.svg") no-repeat center center;
  width: 18px;
  height: 18px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_true:after {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: 3px;
  background: #27AE60;
}

section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_true:before {
  content: "";
  position: absolute;
  bottom: 20px;
  left: calc(50% - 9px);
  background: url("assets/img/filled-check-positive.svg") no-repeat center center;
  width: 18px;
  height: 18px;
}

section.expertise_oskelly .expertise_oskelly_left_right_block:after {
  content: "";
  display: table;
  clear: both;
}

@media only screen and (max-width: 1024px) {
  section.expertise_oskelly {
    padding: 61px 0 61px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block {
    margin-top: 40px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block {
    float: left;
    max-width: 46%;
    width: 290px;
    margin: 0;
    display: block;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block {
    margin: 0;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_true {
    margin: 34px 0 0;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block {
    float: right;
    width: 54%;
    max-width: 100%;
    margin-top: 3px;
  }
}

@media only screen and (max-width: 767px) {
  section.expertise_oskelly {
    padding: 41px 0 18px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block {
    margin-top: 31px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block {
    float: none;
    width: 100%;
    margin-top: 32px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block .block {
    margin-bottom: 22px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block .block .name_block {
    font-size: 14px;
    line-height: 18px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_right_block .block p {
    line-height: 18px;
    font-size: 12px;
    margin-top: 5px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block {
    float: none;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block {
    width: calc(50% - 4px);
    min-height: 140px;
    height: auto;
    padding: 0 16px 20px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_true {
    margin-top: 0;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_true:before {
    bottom: 15px;
  }

  section.expertise_oskelly .expertise_oskelly_left_right_block .expertise_left_block .block.block_false:before {
    bottom: 15px;
  }
}
</style>
